// 退换货结算单
<template>
  <div id="containt">
    <el-tabs v-model="activeName" class="tab-box">
      <el-tab-pane label="常规" name="first">
        <editView v-if="showEdit" visible-key="showEdit" :_dataId.sync="dataId" :processId="processId" :parent-target="_self"
                  @reload="$reloadHandle"></editView>
      </el-tab-pane>
      <el-tab-pane label="列表" name="second">

        <div>
          <vxe-grid show-overflow  :row-config="{ isHover: true }" ref="table-m1" v-bind="vxeOption"
                    @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle"
                    @checkbox-change="({records}) => selectedData = records"
                    @checkbox-all="({records}) => selectedData = records"
                    :checkbox-config="{ labelField: '', highlight: true, reserve: true , range: true}"
          >
            <template #form>
              <div class="clearfix screen-btns" style=" padding-bottom: 6px;">
                <div class="fl">
<!--                  <vxe-button status="primary" class="button-sty" icon="el-icon-bottom"-->
<!--                              v-if="sfSettleExchangeOrderInfoExport"-->
<!--                              @click="doExcle">导出明细-->
<!--                  </vxe-button>-->
                </div>
                <div class="fr" style="display: flex;">
                  <vxe-button status="warning" icon="el-icon-search" style="margin: 0 1px;"
                              class="button-sty" @click="searchEvent">搜索
                  </vxe-button>
<!--                  <div style="display: flex;margin-top: 5px;margin-right: 5px;color: #409eff;" @click="show3 = !show3">-->
<!--                    <svg t="1682558973727" class="icon" viewBox="0 0 1024 1024" version="1.1"-->
<!--                         xmlns="http://www.w3.org/2000/svg" p-id="1587" width="16" height="16">-->
<!--                      <path-->
<!--                        d="M921.6 686.08h-245.76c-10.24 0-20.48-10.24-20.48-20.48s10.24-20.48 20.48-20.48H921.6c10.24 0 20.48 10.24 20.48 20.48s-10.24 20.48-20.48 20.48z m0-122.88h-245.76c-10.24 0-20.48-10.24-20.48-20.48s10.24-20.48 20.48-20.48H921.6c10.24 0 20.48 10.24 20.48 20.48s-10.24 20.48-20.48 20.48z m-166.4-289.28c-2.56 2.56-243.2 227.84-243.2 227.84v389.12l-163.84-81.92v-307.2L112.64 281.6c-2.56-2.56-5.12-5.12-7.68-5.12-15.36-15.36-23.04-35.84-23.04-58.88 0-46.08 38.4-84.48 84.48-84.48h527.36c46.08 0 84.48 38.4 84.48 84.48 0 23.04-10.24 43.52-23.04 56.32zM693.76 179.2H166.4C145.92 179.2 128 197.12 128 217.6c0 10.24 2.56 20.48 10.24 25.6l2.56 2.56 227.84 215.04 15.36 12.8 2.56 25.6-2.56 273.92 81.92 40.96V473.6l15.36-12.8 230.4-212.48 2.56-2.56c7.68-7.68 10.24-15.36 10.24-25.6 7.68-23.04-10.24-40.96-30.72-40.96z m-17.92 588.8H921.6c10.24 0 20.48 10.24 20.48 20.48s-10.24 20.48-20.48 20.48h-245.76c-10.24 0-20.48-10.24-20.48-20.48 0-12.8 7.68-20.48 20.48-20.48z"-->
<!--                        fill="#0ea2f0" p-id="1588"></path>-->
<!--                    </svg>-->
<!--                    <span>更多筛选</span>-->
<!--                  </div>-->

                </div>
              </div>
              <el-collapse-transition name="fade">

                <vxe-form v-show="show3" ref="form" class="screen-box" title-width="7vw"
                          title-align="right" :data="formData" @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent" >
                  <vxe-form-item title="状态:" field="name">
                    <template v-slot>
                      <el-select v-model="formData.stat" :disabled="goodsStatusItem!=='所有'" clearable  style="width:9vw ;">
                        <el-option :value="null" label="全部"></el-option>
                        <el-option :value="1" label="制单"></el-option>
                        <el-option :value="3" label="审核中"></el-option>
                        <el-option :value="5" label="驳回"></el-option>
                        <el-option :value="7" label="取消"></el-option>
                      </el-select>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="是否冲账:" field="name">
                    <template v-slot>
                      <el-select v-model="formData.isReversed" :disabled="goodsStatusItem!=='所有'" clearable  style="width:9vw ;">
                        <el-option :value="null" label="全部"></el-option>
                        <el-option :value="0" label="否"></el-option>
                        <el-option :value="1" label="是"></el-option>
                      </el-select>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="申请单号:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.batchNo" size="small"  style="width:9vw ;" clearable/>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="创建时间:" field="name">
                    <template v-slot>
                      <el-date-picker style="width: 17vw;" v-model="formData.createDate" type="daterange" align="right" unlink-panels
                                      range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                                      :picker-options="pickerOptions" value-format='yyyy-MM-dd'>
                      </el-date-picker>
                    </template>
                  </vxe-form-item>

                </vxe-form>
              </el-collapse-transition>

              <div class="goodsStatus">
                <div v-for="(item, index) in goodsStatusList" :key="index">
                  <div :class="{
											btnGoodsStatusBt1: goodsStatusIndex == index,
											btnGoodsStatusBt: goodsStatusIndex != index
										}" @click="changeGoodsStatus(item, index)">
                    <span>{{ item.name }}</span>
                     <span v-if='item.name!=="所有"' class="num_color" >{{ item.num }}</span>
                  </div>
                </div>
              </div>

            </template>
            <template #pager>
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </template>
            <!-- 操作 -->
            <template #option="{row}">
              <a href="javascript:void(0);" class="a-link" @click="openEditDialog(row, 'edit')">
                <el-tooltip enterable={false} effect="dark" content="查看" placement="top"
                            popper-class="tooltip-skin">
                  <i class="el-icon-edit"/>
                </el-tooltip>
              </a>

              <el-dropdown @command="handleCommand($event, row)">
                <span class="el-dropdown-link">
                  <i class="el-icon-arrow-down el-icon--right" style="color:#00c4b3"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="启动流程" v-if="row.stat == 1 && !row.processId && exchangeBillSubmit">启动流程</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>

            </template>

          </vxe-grid>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-dialog
      title="提示" :visible.sync="dialogVisible" width="30%" >
        <span>{{dialogMsg}}</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="confirm">确 定</el-button>
        </span>
    </el-dialog>

  </div>
</template>

<script>
import editView from './edit.vue';
import {initVxeTable} from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue'
import {mapGetters} from "vuex";
import api from "@/api/projectApi";

import OrgSearch from "@/components/formItem/orgSearch.vue";

import { formatTplSimple } from 'echarts/lib/util/format';
import request from "@/router/axios";
import store from "@/store";
import {indexPageMixins, siteMixins} from "@/mixins/tabChang";
import {doCheckExcle, doDownLoadExcle} from "@/api/intfDownloadRecord/downloadRecord";
import fileNames from "@/api/intfDownloadRecord/fileNames";

export default {
  name: 'application',

  inject: ['reload'],
  mixins: [indexPageMixins,siteMixins],
  components: {editView, pager,
  },
  data() {
    return {
      sfSettleExchangeOrderInfoExport:false,
      exchangeBillSubmit:false,
      isShowUploadInvoice: false,
      applicationAdjustmentAmount:false,
      ids: [],
      isSite: false,
      companyShortName: null,
      total: 0,
      searchValue: null,
      showPage: false,

      applicationReject: false,

      first: true,

      requestParam: {
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 0,  // 页面数据量

        stat: null,
        orgId: null,
        orgIdPath: null,
        orgName: null,
        siteId: null,
        batchNo:null,
        createDate: null,
        createTimeBegin: null,
        createTimeEnd: null,
        isReversed:null,
      },

      formData: {
        stat: null,
        orgId: null,
        orgIdPath: null,
        orgName: null,
        siteId: null,
        batchNo:null,
        createDate: null,
        createTimeBegin: null,
        createTimeEnd: null,
        isReversed:null,
      },
      show3: true,

      sitePromptList: [],
      goodsStatusList: [],//循环列表
      goodsStatusItem: "",//获取点击的元素名称
      goodsStatusIndex: 0,//:class做判断用，默认选中第一个
      dialogMsg: null,
      dialogVisible: false,
      input: '',


      pickerOptions: {

        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      value2: '',
      value3: '',
      value: '',
      activeName: 'second',
      dataId: 0,
      processId:null,

      vxeOption: {},
      // 查询参数


      pageSizes: [10, 20, 100],
      showEdit: false,
      columns: [
        {type: 'checkbox', width: 30, title: '', resizable: false, fixed: 'left'},
        {width: 100, field: 'status', fixed: 'right', title: '操作', showOverflow: true, slots: {default: 'option'}},
        { title: '结算单号', field: 'batchNo', width: 190, slots: {
            // 使用 JSX 渲染
            default: ({row}) => {
              return [
                <span style="color: blue"
                      onClick={($event) => this.addressClickEvent(row, $event)}>{row.batchNo}</span>
              ]
            }
          }
        },
        { title: '状态', field: 'stat', width: 130, slots: {
            default: ({row}) => {
              if (row.stat == 1) {
                return [
                  <div class="txt-status ">
                    <span>制单</span>
                  </div>
                ];
              } else if (row.stat == 3) {
                return [
                  <div class="txt-status neutral">
                    <span>审核中</span>
                  </div>
                ];
              } else if (row.stat == 5) {
                return [
                  <div class="txt-status ">
                    <span>驳回</span>
                  </div>
                ];
              } else if (row.stat == 7) {
                return [
                  <div class="txt-status neutral">
                    <span>完成</span>
                  </div>
                ];
              } else if (row.stat == 9) {
                return [
                  <div class="txt-status neutral">
                    <span>取消</span>
                  </div>
                ];
              }
            }
          }
        },
        { title: '结算总金额', field: 'amount', width: 80},
        { title: '是否冲账', field: 'isReversed', width: 130, slots: {
            default: ({row}) => {
              if (row.isReversed == 0) {
                return [
                  <div class="txt-status ">
                    <span>否</span>
                  </div>
                ];
              } else if (row.isReversed == 1) {
                return [
                  <div class="txt-status neutral">
                    <span>是</span>
                  </div>
                ];
              }
            }
          }
        },
        { title: '创建人', field: 'createBy', width: 80, },
        { title: '创建时间', field: 'createTime', width: 150, },
      ]
    };
  },
  computed: {
    ...mapGetters(["permissions"])
  },
  watch: {
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
    activeName(newVal) {
      if (newVal === 'second' && this.editViewDataUpdateFlag) {
        this.getTableData()
      }
    },
    'formData.siteName': {
      handler(newVal) {
        if (!newVal) {
          this.formData.siteId = null
        }
      },
      deep: true
    },

    'formData.createDate': {
      handler(newVal, oldVal) {
        if (newVal != null && newVal.length !== 0) {
          this.formData.createTimeBegin = newVal[0]
          this.formData.createTimeEnd = newVal[1]
        } else if (newVal == null) {
          this.formData.createTimeBegin = null
          this.formData.createTimeEnd = null
        }
      },
      deep: true,
    },
  },
  created() {
    this.sfSettleExchangeOrderInfoExport = this.permissions["sfSettleExchangeOrderInfoExport"];
    this.applicationHandle = this.permissions["applicationHandle"];
    this.exchangeBillSubmit = this.permissions["exchangeBillSubmit"];
    this.getCompanyMsg();

    const userInfo = store.getters.userInfo;
    console.log("网点信息:-------",store.getters.userInfo)
    if (userInfo.snUserId) {
      this.isSite = true;
    }
    console.log("是否为服务商" + this.isSite)
  },

  mounted() {
    // this.loadTabOption()
    this.initSearchDate()
    this.getProcessDefinitions()
  },

  methods: {
    //导出
    doExcle(){
      // const  result =
      this.$mask.open()
      doCheckExcle(fileNames.site).then(response => {
        if (response.data.msg=="success"){
          doDownLoadExcle(api.sfExchangeOrder.doExcelUrl, this.requestParam).then(res => {
            this.$mask.close()
            this.$message({
              type: res.data.type,
              message: res.data.content
            })
          }).catch(() => {
            this.$mask.close()
          })
        }else{
          this.$mask.close()
          this.$message({
            type: "error",
            message: response.data.msg
          });
        }
      }).catch(() => {
        this.$mask.close()
      })
    },
    toFilterData() {
      this.searchEvent();
     },
    getCompanyMsg() {
      request({
        url: '/basic/soOrderIssue/getCompanyMsg',
        method: 'post',
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        this.companyShortName = response.data.data.companyShortName
        console.log("对应厂商信息1-------",response.data.data)
      })
    },
    goBackIndex(){
      this.getTableData()
      this.flushed()
    },

    initSearchDate() {
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      this.formData.createDate = [start, end]
      this.requestParam.createTimeBegin = start
      this.requestParam.createTimeEnd = end
    },

    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
      this.loadTabOption()
    },

    // 服务商提示选中
    handleSiteSelect(data) {
      console.log('selectData', data)
      this.formData.siteId = data.id
    },

    // 获取服务商提示
    querySiteSearch(queryStr, callback) {
      this.$http({
        url: api.snUser.getPromptDataUrl,
        method: 'post',
        data: {userName: queryStr}
      }).then(res => {
        console.log(res.data.data, '网点提示内容')
        let temp = []
        res.data.data.forEach(item => {
          temp.push({value: item.userName, id: item.id})
        })
        callback(temp)
      })
    },

    serviceTypeHandleChange(data) {
      console.log('选中的服务类型数据', data)
    },
    // 加载tab数据
    async loadTabOption() {
      await this.$http({
        url: api.sfExchangeOrder.getCountUrl,
        method: 'post',
        data: this.requestParam
      }).then(res => {
        this.goodsStatusList = res.data.data
        if (this.first) {
          this.initSearchDate()
          this.requestParam.stat = this.goodsStatusList[0].stat
          this.formData.stat = this.goodsStatusList[0].stat
        }
        this.first = false
      })
    },

    // 选中的按钮
    changeGoodsStatus(item, index) {
      this.goodsStatusItem = item.name;//获取点击的元素
      this.goodsStatusIndex = index;//将点击元素的下标和：class中的作对比

      let temp = null
      if (item.name === '制单') {
        temp = 1
      } else if (item.name === '审核中') {
        temp = 3
      } else if (item.name === '驳回') {
        temp = 5
      } else if (item.name === '取消') {
        temp = 7
      }

      this.requestParam.stat = temp
      this.formData.stat = temp

      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.getTableData()
    },


    // 加载table数据
    async getTableData() {
      await this.loadTabOption()
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: api.sfExchangeOrder.getPageDataUrl,
        param: this.requestParam,
        method: 'post',
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);
      this.editViewDataUpdateFlag = false;
      this.flushed()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData();
    },

    // 搜索
    searchEvent() {
      this.requestParam.fuzzySearchIsEnable = !this.show3

      let formData = this.formData;
      this.requestParam.fuzzySearchValue = this.searchValue
      this.requestParam.stat = formData.stat
      this.requestParam.orderNo = formData.orderNo
      this.requestParam.orgId = formData.orgId
      this.requestParam.siteId = formData.siteId
      this.requestParam.isReversed = formData.isReversed
      this.requestParam.batchNo = formData.batchNo

      this.requestParam.createTimeBegin = formData.createTimeBegin
      this.requestParam.createTimeEnd = formData.createTimeEnd

      // if (formData.createTime != null && formData.createTime.length === 2) {
      //   this.requestParam.createTimeBegin = formData.createTime[0]
      //   this.requestParam.createTimeEnd = formData.createTime[1]
      // }

      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.getTableData()
    },

    // 操作
    handleCommand(command, row) {
      this.currentRowId = row.id
      console.log(command, row, "command,b的值");
      if (command === '启动流程') {
        if (!row.applyContent || row.applyContent=='') {
          this.$message.error('启动流程前请先填写申请内容并保存');
          return;
        }
        this.$mask.open()

        this.$http({
          url: api.act.startWfUrl,
          method: 'post',
          data: {id: row.id, tableKey: "SfSettleExchangeOrderBatch", orgId: row.orgId, orderNo: row.batchNo},
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          if (response.data.type == "success") {
            this.$message({message: response.data.content, type: 'success'});
            this.$http({
              url: api.sfExchangeOrder.startBatchUrl,
              method: 'post',
              data: row,
              isLoading: true,
              modalStrictly: true,
            }).then(response => {
              if (response.data.type == "success") {
                this.$message({message: response.data.content, type: 'success'});
                this.getData()
                this.$mask.close()
              } else {
                this.$message({message: response.data.content, type: 'warning'});
                this.$mask.close()
              }
            })
            // this.reload();
          } else {
            this.$message({message: response.data.content, type: 'warning'});
          }
          this.$mask.close()
        })
      }

    },

    getProcessDefinitions() {
      request({
        url: api.act.getProcessDefinitionsUrl,
        method: 'post',
        // data:this.formData,
        data: {tableKey: "SfSettleExchangeBatch",},
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        this.processDefinitions = response.data.data
      })
    },

    dialogClose() {
      this.visiable = false
      this.$emit('update:visiable', this.visiable)
    },

    // 复选框选中
    selectChangeEvent({records}) {
      console.log("数据",records)
      this.selectedData = records
    },

    // 详情显示
    showInfo(row, $event) {
      this.openEditDialog(row, 'info')
    },


    // 重置
    resetEvent() {
      this.formData = {
        feeType: '',
        name: ''
      }

      this.requestParam.searchCount = false
      this.requestParam.current = 1
      this.requestParam.name = ''
      this.requestParam.feeType = ''

      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    ///////////////////////////////////////////////////////////////////////////////////////////////////

    // 选中的按钮
    addressClickEvent(row, id) {
      this.openEditDialog(row);
      console.log(row, id, "row");
    },

    optionChange(value, target) {
      console.log(111, "11111111");
      console.log(value);
      // var select = document.querySelectorAll(".status_select");
      console.log('接受的option的值1', target)
      // var grade = select.options[select.selectedIndex].value;
      // alert(grade);
      // console.log(grade, "grade的值");
      if (target == 2) {
        this.open()
      }
    },

    gradeChange() {
      console.log(11, "11111111111");
      var objS = document.getElementById("pid");
      var grade = objS.options[objS.selectedIndex].grade;
      alert(grade);
      console.log(grade);
    },


    // 新增
    openEditDialog(row, type) {

      this.dataId = !row.id || typeof row.id == 'object' ? 0 : row.id;
      this.processId=row.processId
      this.activeName = 'first';
      this.$openEditView('showEdit');
      console.log('触发了跳转');
    },


  }
};
</script>
<style lang="scss" scoped>
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

::v-deep .vxe-grid .screen-btns {
  // margin-bottom: 6px;
  border-bottom: 1px solid #ededed !important;
}

.vxe-grid .a-link {
  color: #00c4b3;
  margin-right: 0px !important;
}

// 弹窗过渡显示效果
// 进场时候过渡的开始状态和离场的结束状态
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

// 指定过渡的属性和时间，同样是进场和离场的过渡时间
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

// 进场时候过渡的结束状态和离场的开始状态
.fade-enter-to,
.fade-leave {
  opacity: 1;
}


// 选中的按钮

.goodsStatus {
  //按钮水平
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-content: space-between;
}

.btnGoodsStatusBt {
  //白底按钮
  // width: 100px;
  margin-right: 20px;
  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  text-align: center;
  background: #fff;
  padding: 5px;
}

.btnGoodsStatusBt1 {
  //红底按钮
  // width: 100px;
  margin-right: 20px;

  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  color: #409eff;
  text-align: center;
  border-bottom: 3px solid #409eff;
  padding: 5px;
}

.num_color {
  display: inline-block;
  margin-left: 5px;
  /* width: 15px; */
  font-size: 12px;
  padding: 4px;
  line-height: 7px;
  height: 12px;
  color: #409eff;
  border-radius: 4px 4px;
  background-color: #ddeaff;
}

// 隐藏搜索框 标题的宽度
.vxe-grid .vxe-form--item .vxe-form--item-title .vxe-form--item-title-label {
  font-size: 12px;
  display: inline-block;
  width: 65px !important;
}


.active1 {
  // height: 100vh;
  height: calc(100vh - 77px);
  padding-bottom: 29px !important;
}

.no-active2 {
  height: calc(100vh - 70px);
  padding-bottom: 43px !important;
}

#avue-view {
  overflow: unset !important;
}

.avue-view {
  overflow: unset !important;

}

// ::v-deep .vxe-grid .vxe-pager {
//     font-size: 12px;
//     height: 25px !important;
// 	// overflow: hidden;
// }
::v-deep .el-collapse-item__wrap {
  will-change: height;
  background-color: #FFF;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: none !important;
}

::v-deep .el-collapse-item__header {
  height: 0px;
  line-height: 0px;
  border: none !important;
}

::v-deep .el-collapse-item__header.is-active {
  border-bottom: none;
}

::v-deep .el-collapse {
  border-top: 1px solid #002c93;
  border-bottom: 1px solid #EBEEF5;
  border: none;
}

::v-deep .el-collapse-item__arrow {
  position: relative;
  top: -140px;
  font-size: 18px;
  color: #0077ff;
}

::v-deep .vxe-grid .vxe-form--item-title .vxe-form--item-title-content {
  -webkit-box-flex: 1;
  display: inline-block;
  width: 55px;
  -ms-flex-positive: 1;
  flex-grow: 1;
}
// 隐藏搜索栏
.screen-box{
  display: flex;



}
::v-deep .vxe-grid .vxe-form.screen-box {
    padding: 4px 10px 2px 0;
    }

::v-deep .vxe-grid .el-input .el-input__inner {
    height: 28px !important;
}
</style>
